module.exports = __webpack_public_path__ + "d9c722c9d0df598919d8b9cc97bef041.png";